/*  ========================================================================
    # Scripts - Header Toggle
    ========================================================================  */

/**
 * Script that handles.
 */
const HeaderToggle = {
  cfg: {
    props: window.headerToggleProps,
    toggleContainer: document.querySelector('.c-header__toggle'),
    toggle: document.querySelectorAll('.c-header__toggle span')[1],
    classes: {
      public: 'c-header__toggle--public',
      memberArea: 'c-header__toggle--member-area'
    }
  },

  /**
   * Navigate go given URL.
   *
   * @param {string} url
   */
  navigateToUrl(url) {
    setTimeout(() => {
      window.location.href = url;
    }, 100);
  },

  /**
   * Handler.
   */
  handler() {
    this.cfg.toggle.addEventListener('click', () => {
      if (this.cfg.toggleContainer.classList.contains(this.cfg.classes.public)) {
        this.cfg.toggleContainer.classList.remove(this.cfg.classes.public);
        this.cfg.toggleContainer.classList.add(this.cfg.classes.memberArea);
        if (!!this.cfg.props.isUserLoggedIn === true) {
          this.navigateToUrl(this.cfg.props.headerToggleMemberArea);
        }
        if (!!this.cfg.props.isUserLoggedIn === false) {
          this.navigateToUrl(this.cfg.props.headerToggleFallback);
        }
      } else {
        this.cfg.toggleContainer.classList.remove(this.cfg.classes.memberArea);
        this.cfg.toggleContainer.classList.add(this.cfg.classes.public);
        this.navigateToUrl(this.cfg.props.headerTogglePublic);
      }
    });
  },

  /**
   * Initialize.
   */
  init() {
    if (this.cfg.toggleContainer !== undefined && this.cfg.toggleContainer !== null) {
      this.handler();
    }
  }
};

export default HeaderToggle;
